var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('SearchForm',{ref:"cardSearchForm",attrs:{"caption":"Recherche","structure":{
                rows: [
                    {
                        cols: [
                            {
                                fields: [
                                    {
                                        id: 'start'
                                    }
                                ]
                            },
                            {
                                fields: [
                                    {
                                        id: 'end'
                                    }
                                ]
                            }
                        ]
                    }
                ],
                fields: [
                    {
                        id: 'start',
                        type: 'date',
                        label: _vm.Core.Definition.getDefinition('Début'),
                    },
                    {
                        id: 'end',
                        type: 'date',
                        label: _vm.Core.Definition.getDefinition('Fin'),
                    }
                ]
            }},on:{"onSubmit":_vm.search,"onReset":_vm.reset}}),_c('Request',{ref:"request",attrs:{"onRequestSuccess":_vm.requestSuccess,"root":"/report/event-popularity"}},[_vm._t("default",[(_vm.dataWeekDayPie !== false && _vm.dataHourlyLine !== false)?_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('CardChartLine',{attrs:{"chart":{
                                 labels: _vm.dataHourlyLine.labels,
                                 sets:[
                                      {
                                        label: _vm.Core.Definition.getDefinition('Visites à l\'heure'),
                                        backgroundColor: 'rgba(102, 217, 255, .5)',
                                        borderColor: 'rgba(255,255,255,.5)',
                                        data: _vm.dataHourlyLine.data
                                      }
                                    ]
                            }}})],1),_c('b-col',{attrs:{"lg":"6"}},[_c('CardChartPie',{attrs:{"chart":{
                                 labels: _vm.dataWeekDayPie.labels,
                                 sets:[
                                      {
                                       label: _vm.Core.Definition.getDefinition('Jour de la semaine'),
                                      backgroundColor: [
                                        'rgba(102, 217, 255)',
                                        'rgba(102, 140, 255)',
                                        'rgba(153, 102, 255)',
                                        'rgba(255, 102, 102)',
                                        'rgba(255, 140, 102)',
                                        'rgba(255, 179, 102)',
                                        'rgba(255, 190, 102)'
                                      ],
                                        data: _vm.dataWeekDayPie.data
                                      }
                                  ]
                            }}})],1)],1):_vm._e()],{"slot":"body"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }